module.exports = require("moment-timezone");


/*****************
 ** WEBPACK FOOTER
 ** external "moment-timezone"
 ** module id = 23
 ** module chunks = 0 1
 **/